<template>
    <div class="element-calendly is-empty">
        <calendar-embed :src="link()" :type="options('type')"></calendar-embed>
    </div>
</template>

<script>
import Calendar from '../../../components/Calendar'
import store from '../../store'

export default {
        props: {
            definition: { type: Object, required: true },
            element:    { type: Object, required: true },
        },
        methods: {
            classes(index) { return store.getters['classes'](index) },
            options(value) { return store.getters['options'](this.definition, value) },
            link() {
                let type = this.options('type')
                let link = this.options('link')
                let cfLink = this.options('cfLink')
                if ((type == 'calendly' || type == 'greminders' || type == 'zoomscheduler') && !link && cfLink) {
                    let macro = store.state.macros.find(e => e.key == cfLink)
                    if (macro && macro.value) {
                        let regex = /href="(.*?)"/g
                        let matches = regex.exec(macro.value)
                        if (matches && matches[1]) {
                            link = matches[1]
                            if (type == 'calendly' && link.startsWith('https://calendly')) {
                                return link
                            }
                            if (type == 'greminders' && link.startsWith('https://app.greminders.com')) {
                                return link
                            }
							if (type == 'zoomscheduler' && link.startsWith('https://scheduler.zoom.us')) {
								return link
							}
                        }
                    }

                    return ''
                }

                return link
            }
        },
        components: {'calendar-embed' : Calendar}
    }
</script>
